// extracted by mini-css-extract-plugin
module.exports = {"globalModal":"Modals_globalModal__HFEMG","modal":"Modals_modal__LpmUI"};